import { render, staticRenderFns } from "./content-wrapper.vue?vue&type=template&id=257c2b01&scoped=true&"
import script from "./content-wrapper.vue?vue&type=script&lang=ts&"
export * from "./content-wrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257c2b01",
  null
  
)

export default component.exports